module.exports = __webpack_public_path__ + "img/pic-honor-no.60ff6b74.png";